import { render, staticRenderFns } from "./AdminProtectedDocuments.vue?vue&type=template&id=13bb53df&scoped=true"
import script from "./AdminProtectedDocuments.vue?vue&type=script&lang=js"
export * from "./AdminProtectedDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb53df",
  null
  
)

export default component.exports